// This file was generated by lezer-generator. You probably shouldn't edit it.
export const bodyContent = 15,
  HttpMessage = 1,
  RequestLine = 2,
  Method = 3,
  UrlPath = 4,
  HttpVersion = 5,
  StatusLine = 6,
  StatusCode = 7,
  StatusText = 8,
  HeaderName = 9,
  HeaderValue = 10,
  BodyText = 11;
